<script lang="ts">
  import { onMount } from 'svelte';
  import { navigate, Link } from 'svelte-routing';
  import { api } from '../lib/api/client';
  import { auth, isAuthenticated } from '../lib/stores/auth';
  import { t } from '../lib/i18n/index.ts';

  // canReset is whether this server emails reset links (spec 001 FR-018).
  let canReset = $state(false);
  onMount(async () => {
    try {
      canReset = (await api.get<{ features: string[] }>('/server')).features.includes('password_reset');
    } catch {
      canReset = false;
    }
  });

  let username = $state('');
  let password = $state('');
  let error = $state('');
  let loading = $state(false);

  // next sends the person back where they were headed, such as an invite.
  const next = (() => {
    const n = new URLSearchParams(window.location.search).get('next') ?? '/';
    return n.startsWith('/') && !n.startsWith('//') ? n : '/';
  })();

  $effect(() => {
    if ($isAuthenticated) {
      navigate(next, { replace: true });
    }
  });

  async function handleSubmit() {
    error = '';
    loading = true;
    try {
      await auth.login(username, password);
      navigate(next);
    } catch (e: any) {
      error = e.message || t('authSignInFailed');
    } finally {
      loading = false;
    }
  }
</script>

<div class="flex items-center justify-center min-h-full flex-1 p-4">
  <div class="card p-8 w-full max-w-md">
    <h1 class="text-2xl font-bold mb-6 text-center" style="color: var(--theme-accent);">
      {t('authSignInTitle')}
    </h1>

    {#if error}
      <div class="mb-4 p-3 rounded text-sm"
           style="background-color: var(--theme-error); color: var(--theme-base); opacity: 0.9;">
        {error}
      </div>
    {/if}

    <form onsubmit={(e: SubmitEvent) => { e.preventDefault(); handleSubmit(); }} class="flex flex-col gap-4">
      <div>
        <label for="username" class="block text-sm font-medium mb-1">{t('authUsername')}</label>
        <input id="username" type="text" class="input w-full" bind:value={username} required
               autocomplete="username" autocapitalize="none" />
      </div>

      <div>
        <label for="password" class="block text-sm font-medium mb-1">{t('authPassword')}</label>
        <input id="password" type="password" class="input w-full" bind:value={password} required
               autocomplete="current-password" />
      </div>

      <button type="submit" class="btn btn-primary w-full mt-2" disabled={loading}>
        <i aria-hidden="true" class="las la-sign-in-alt mr-1"></i>{loading ? t('authSigningIn') : t('authSignIn')}
      </button>
    </form>
    {#if canReset}
      <p class="text-sm text-center mt-4"><Link to="/forgot">{t('authForgotPassword')}</Link></p>
    {/if}
  </div>
</div>
